/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'
export function getListSaleEmployee(query) {
  return request({
    url: '/report-service/v1/revenue-report/sale-agent',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListSaleEmployeeExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/sale-agent/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
export function getPieChart(query) {
  return request({
    url: '/report-service/v1/revenue-report/sale-agent/pie-chart',
    method: 'get',
    params: query
  })
}

export function getLineChartApi(query) {
  return request({
    url: '/report-service/v1/revenue-report/sale-agent/growth-chart',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getHistogramChartApi(query) {
  return request({
    url: '/report-service/v1/revenue-report/sale-agent/histogram-chart',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}

export function getAllSales() {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: {
      recordEmpl: true
    }
  })
}
